import { actionTypes } from '../constants/actionTypes';
import { initialBankAccountFilters, initialManuallyEnteredValues } from '../initializeObjects/bankAccountFilters';

const pageViewNumbers = [10, 25, 50, 100, 150, 200];

const initialPagination = {
  pages: [],
  pageSelected: 1,
  pageNext: false,
  pagePrevious: false,
  totalPages: 5
};

export const bankAccountFilters = (state = initialBankAccountFilters, action) => {
  switch (action.type) {
    case actionTypes.BANK_ACCOUNT_FILTERS:
      return Object.assign({}, state, action.payload);
  }
  
  return state;
};

export const pagination = (state = initialPagination, action) => {
  switch (action.type) {
    case actionTypes.BANK_ACCOUNT_PAGINATION:
      return Object.assign({}, state, action.payload);
  }

  return state;
};

export const bankAccountTransactions = (state = [], action) => {
  switch (action.type) {
    case actionTypes.BANK_ACCOUNT_TRANSACTIONS:
      return [].concat(action.payload);
  }

  return state;
};

export const viewsPerPage = (state = 10, action) => {
  switch (action.type) {
    case actionTypes.SET_PAGE_VEIW_SIZE:
      return action.payload;
  }

  return state;
};

export const eventsNumber = (state = pageViewNumbers, action) => {
  switch (action.type) {
    case actionTypes.PAGE_VIEW_NUMBERS:
      return action.payload;
  }

  return state;
};

export const displayNoBankTransactions = (state = false, action) => {
  switch (action.type) {
    case actionTypes.DISPLAY_NO_BANK_TRANSACTIONS:
      return action.payload;
  }

  return state;
};

export const availableAccessCodeCount = (state = 0, action) => {
  switch (action.type) {
    case actionTypes.AVAILABLE_ACCESS_CODE_COUNT:
      return action.payload;
  }

  return state;
};


export const printUrl = (state = '', action) => {
  switch (action.type) {
    case actionTypes.PRINT_URL:
      return action.payload;
  }
  
  return state;
};

export const downloadDropdownOpen = (state = false, action) => {
  switch (action.type) {
    case actionTypes.DOWNLOAD_DROPDOWN_OPEN:
      return action.payload;
  }
  
  return state;
};

export const isDisplayBankDialogActions = (state = false, action) => {
  switch (action.type) {
    case actionTypes.IS_DISPLAY_BANK_DIALOG_ACTIONS:
      return action.payload;
  }

  return state;
};

export const isDisplayBankDetailsLink = (state = false, action) => {
  switch (action.type) {
    case actionTypes.IS_DISPLAY_BANK_DETAILS_LINK:
      return action.payload;
  }

  return state;
};

export const bankDetailValues = (state = {}, action) => {
  switch (action.type) {
    case actionTypes.BANK_DETAIL_VALUES:
      return Object.assign({}, state, action.payload);
  }

  return state;
};

export const isDisplayProgramDialogActions = (state = false, action) => {
  switch (action.type) {
    case actionTypes.IS_DISPLAY_PROGRAM_DIALOG_ACTIONS:
      return action.payload;
  }

  return state;
};

export const programDetailValues = (state = {}, action) => {
  switch (action.type) {
    case actionTypes.PROGRAM_DETAIL_VALUES:
      return Object.assign({}, state, action.payload);
  }

  return state;
};

export const isDisplayDetailsAlerts = (state = false, action) => {
  switch (action.type) {
    case actionTypes.IS_DISPLAY_DETAILS_ALERTS:
      return action.payload;
  }

  return state;
};

export const isBankViewClicked = (state = false, action) => {
  switch (action.type) {
    case actionTypes.IS_BANK_VIEW_CLICKED:
      return action.payload;
  }

  return state;
};

export const isDisplayFromDateCalendar = (state = false, action) => {
  switch (action.type) {
    case actionTypes.IS_DISPLAY_FROM_CALENDAR:
      return action.payload;
  }

  return state;
};

export const isDisplayToDateCalendar = (state = false, action) => {
  switch (action.type) {
    case actionTypes.IS_DISPLAY_TO_CALENDAR:
      return action.payload;
  }

  return state;
};

export const isDisplayBankViewCatalog = (state = false, action) => {
  switch (action.type) {
    case actionTypes.IS_DISPLAY_BANK_VIEW_CATALOG:
      return action.payload;
  }

  return state;
};

export const manuallyEnteredDate = (state = initialManuallyEnteredValues, action) => {
  switch (action.type) {
    case actionTypes.MANUALLY_ENTERED_DATE:
      return Object.assign({}, state, action.payload);
  }

  return state;
};

